export interface ReportTableField {
    name: string;
    grower_name: string;
    grower_id: number | null;
    service_provider_id: number | null;
    service_provider_name: string;
    account_manager_id: number | null;
    active_enrollment_tier: number | null;
}

export enum ReportProcessingStatus {
    PENDING = "PENDING",
    PROCESSING = "PROCESSING",
    COMPLETED = "COMPLETED",
    FAILED = "FAILED",
}

export enum ReportType {
    PERFORMANCE_V2 = "performancev2",
    TRIAL = "trial",
}

export interface ReportTableRow {
    id: number;
    name: string | null;
    report_type: ReportType | string;
    status: number;
    processing_status: ReportProcessingStatus;
    year: number;
    organization_id: number;
    organization_name: string;
    organization_type: string;
    service_provider_name: string | null;
    account_manager_id: number | null;
    fields: ReportTableField[];
    pdf_url: string | null;
    excel_url: string | null;
    created_date: string;
}

export function getReportTypeLabel(reportType: ReportType | string): string {
    if (reportType === ReportType.TRIAL) return "Trial Report";
    return "Performance Report";
}

export function formatReportType(reportType: string): string {
    return reportType
        .replace(/v2/g, "")
        .replace(/_/g, " ")
        .replace(/\b\w/g, (match) => match.toUpperCase());
}

export function formatReportStatus(
    processingStatus: ReportProcessingStatus,
): "Completed" | "Processing" | "Error" {
    if (processingStatus === ReportProcessingStatus.FAILED) return "Error";
    if (processingStatus === ReportProcessingStatus.COMPLETED) return "Completed";
    return "Processing";
}

export function isReportOrganizationServiceProvider(report: ReportTableRow): boolean {
    return report.organization_type === "service provider";
}
